import axios from 'axios';
let baseURL = process.env.NODE_ENV === 'development' ? '/api/' : 'https://api.lvshuhualv.com/';

let ajax = axios.create({
    baseURL,
    withCredentials: true,
});

ajax.interceptors.request.use(function (config) {
    !config.headers.authToken &&
        Object.assign(config.headers, {
            authToken: localStorage.getItem('authToken'),
        });

    return config;
});
ajax.interceptors.response.use(
    function (res) {
        return res.data;
    },
    function (error) {
        return Promise.reject('网络错误');
    }
);

export default ajax;
